import React from "react";
import BottomSheet from "../../../components/BottomSheet";

const CategoryInfo = ({ openCatInfo, setOpenCatInfo }) => {
  const { value, name, description } = openCatInfo;

  return (
    <BottomSheet
      isOpen={openCatInfo !== false}
      setClose={setOpenCatInfo}
      classNames={"category-info-holder"}
      className={"category-info"}
      viewerClassName={"category-info-viewer"}
    >
      <h4 className={"title"}> {name || value} </h4>
      <p className={"description"}>{description}</p>
      {/*<Button type={"link"} className={"btn-continue"}>*/}
      {/*  بیشتر بخوانید <span className={"icon-arrow-bottom-solid"}> </span>*/}
      {/*</Button>*/}
    </BottomSheet>
  );
};

export default CategoryInfo;
